import { isRedoEmailAddress } from "@redotech/account-common/redo-domains";
import { isWelcomeRoute } from "../../../onboarding/first-install-redirect";
import { isRoleStepRequired } from "../../../welcome/welcome-flow";

export interface JobLevelBackfillUser {
  email: string;
  jobProfile?: { job?: readonly string[] | null; level?: string | null };
}

export function shouldShowJobLevelBackfillPrompt(args: {
  user: JobLevelBackfillUser | null | undefined;
  pathname: string;
}): boolean {
  const { user, pathname } = args;
  if (!user || isWelcomeRoute(pathname)) {
    return false;
  }
  if (isRedoEmailAddress(user.email)) {
    return false;
  }
  return isRoleStepRequired(user.jobProfile);
}
